import { alpha } from '@mui/material/styles';

export const CONTROL_CONTEXTS = {
  FILTER_BAR: 'filterBar',
  OBJECT_TOOLBAR: 'objectToolbar',
  MENU_TOOLBAR: 'menuToolbar',
};

export const CONTROL_SLIDER_SIZES = {
  width: 184,
  labelWidth: 72,
  trackWidth: 50,
  thumbSize: 14,
  presetButtonWidth: 30,
  presetButtonOffset: 3,
};

const CONTROL_SPECS = {
  [CONTROL_CONTEXTS.FILTER_BAR]: {
    height: 30,
    radius: 4,
    fontSize: 12,
    labelFontSize: 9,
    optionFontSize: 11,
    optionSubLabelFontSize: 7.5,
    iconSize: 15,
    gap: 0.5,
    iconLabelGap: 0.125,
    buttonPx: 0.9,
    buttonMinWidth: 34,
  },
  [CONTROL_CONTEXTS.OBJECT_TOOLBAR]: {
    height: 26,
    radius: 4,
    fontSize: 11,
    labelFontSize: 8,
    optionFontSize: 10.5,
    optionSubLabelFontSize: 7.5,
    iconSize: 13.5,
    gap: 0.75,
    iconLabelGap: 0.125,
    buttonPx: 0.65,
    buttonMinWidth: 30,
  },
  [CONTROL_CONTEXTS.MENU_TOOLBAR]: {
    height: 24,
    radius: 4,
    fontSize: 11,
    labelFontSize: 10,
    optionFontSize: 10,
    optionSubLabelFontSize: 10,
    iconSize: 13,
    gap: 0.5,
    iconLabelGap: 0.125,
    buttonPx: 0.65,
    buttonMinWidth: 34,
  },
};

export const getControlTokens = (theme, context = CONTROL_CONTEXTS.FILTER_BAR) => {
  const spec = CONTROL_SPECS[context] || CONTROL_SPECS[CONTROL_CONTEXTS.FILTER_BAR];
  const borderColor = theme.controls?.border || (theme.palette.mode === 'light'
    ? alpha(theme.palette.common.black, 0.23)
    : alpha(theme.palette.common.white, 0.23));
  const dividerColor = theme.palette.mode === 'light'
    ? alpha(theme.palette.common.black, 0.12)
    : alpha(theme.palette.common.white, 0.12);
  const surface = theme.controls?.surface || theme.tableHeader?.highlight || theme.palette.action.hover;
  const selected = theme.palette.mode === 'dark'
    ? alpha(theme.palette.primary.main, 0.3)
    : alpha(theme.palette.primary.main, 0.15);
  const selectedHover = theme.palette.mode === 'dark'
    ? alpha(theme.palette.primary.main, 0.4)
    : alpha(theme.palette.primary.main, 0.25);

  return {
    ...spec,
    context,
    borderColor,
    dividerColor,
    surface,
    selected,
    selectedHover,
    hover: theme.controls?.hover || theme.palette.action.hover,
    textColor: theme.palette.text.secondary,
    selectedColor: theme.palette.primary.main,
  };
};

export const getControlMenuPaperSx = (theme, context = CONTROL_CONTEXTS.FILTER_BAR) => {
  const tokens = getControlTokens(theme, context);

  return {
    width: 'auto',
    backgroundColor: theme.background?.transparent || theme.palette.background.paper,
    backdropFilter: 'blur(8px)',
    borderRadius: `${tokens.radius + 4}px`,
    mt: 0.5,
    '&::-webkit-scrollbar': { width: '8px' },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.2)'
        : 'rgba(0, 0, 0, 0.2)',
      borderRadius: `${tokens.radius}px`,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.3)'
        : 'rgba(0, 0, 0, 0.3)',
    },
  };
};
